import { CONFIGURACION_REGIMENES_FISCALES, CONFIGURACION_GIROS, CONFIGURACION_MEMBRESIAS, CONFIGURACION_METODO_PAGO } from '../actions/types';

const initialState = {
    regimenes_fiscales: {
        listado: []
    },
    giros: {
        listado: []
    },
    membresias: {
        listado: []
    },
    metodo_pago: {
        marca: null,
        digitos: null,
        expiracion_mes: null,
        expiracion_ano: null
    }
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case CONFIGURACION_REGIMENES_FISCALES.BUSCAR:
            return {
                ...state,
                regimenes_fiscales: {
                    ...state.regimenes_fiscales, 
                    listado: payload
                }
            };

        case CONFIGURACION_GIROS.BUSCAR:
            return {
                ...state,
                giros: {
                    ...state.giros, 
                    listado: payload
                }
            };

        case CONFIGURACION_MEMBRESIAS.BUSCAR:
            return {
                ...state,
                membresias: {
                    ...state.membresias,
                    listado: payload
                }
            };

        case CONFIGURACION_METODO_PAGO.OBTENER:
        case CONFIGURACION_METODO_PAGO.ACTUALIZAR:
            return {
                ...state,
                metodo_pago: payload
            };

        case CONFIGURACION_METODO_PAGO.ELIMINAR:
            return {
                ...state,
                metodo_pago: { marca: null, digitos: null, expiracion_mes: null, expiracion_ano: null }
            };

        default:
            return state;
    }
}